import { Tooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";
import { efficiencyKpiManager } from "@features/mmm/utils/efficiency-kpi-manager";
import { MetricFormatters } from "@north-beam/nb-client-side";

import {
  type Kpi,
  type ModelMetadataKpiFormula,
} from "../../explore-budgets/client-setting/types";

interface Props {
  sumOfSpendOnChannel: number;
  sumOfKpiOnChannel: number;
  spend: number;
  selectedKpi: ModelMetadataKpiFormula;
}

export const KpiSummaries = ({
  sumOfSpendOnChannel,
  sumOfKpiOnChannel,
  selectedKpi,
  spend,
}: Props) => {
  const { user } = useUser();
  const {
    kpiFormatter,
    efficiencyKpiType,
    efficiencyKpiFormatter,
    efficiencyKpiCalculator,
  } = efficiencyKpiManager(selectedKpi as Kpi, user);

  return (
    <div className="space-y-4">
      <div>
        <div className="text-cosmic text-5xl mt-5 mb-2">
          {efficiencyKpiFormatter(
            efficiencyKpiCalculator(sumOfSpendOnChannel, sumOfKpiOnChannel),
          )}
        </div>
        <div className="text-gray+2 text-xs font-semibold -mt-2">
          i{efficiencyKpiType}
        </div>
      </div>
      <div className="flex items-center min-w-0">
        <div className="pr-3 min-w-0 flex-grow truncate">
          <div className="text-cosmic text-2xl leading-7 truncate">
            {kpiFormatter(sumOfKpiOnChannel)}
          </div>
          <div className="text-gray+2 font-semibold text-sm truncate">
            <Tooltip content={selectedKpi.friendly_name} noInfoCircle>
              {selectedKpi.friendly_name}
            </Tooltip>
          </div>
        </div>
        <div className="border-l px-4">
          <div className="text-cosmic text-2xl leading-7">
            {MetricFormatters.currency(spend, user.currencies.currentCurrency, {
              precision: "approximate",
            })}
          </div>
          <div className="text-gray+2 font-semibold text-sm">Spend</div>
        </div>
      </div>
    </div>
  );
};
